import React from 'react';
import PropTypes from 'prop-types';

import insulationIcon from '../assets/images/eriste_2.png';
import contentIcon from '../assets/images/sisalto_1.png';
import valveIcon from '../assets/images/valve.png';

class Card extends React.Component {

  render() {
    const {title, children, iconClass, className, contentIc, insulationIc, valveIc, settingsMenu, desc} = this.props;

    return (
      <div className={'card ' + className || ''}>
        <div className="card-header">
          {title}
          {settingsMenu ? settingsMenu : null}
          <div className="card-header-icon">
            <i className="triangle" />
            {iconClass ? <i className={iconClass} /> : null }
            {insulationIc ? <img src={insulationIcon} style={{marginTop: -10 + 'px'}} /> : null }
            {contentIc ? <img src={contentIcon} style={{marginTop: -10 + 'px'}} /> : null }
            {valveIc ? <img src={valveIcon} style={{marginTop: -10 + 'px'}} /> : null }
          </div>
        </div>
        <div className="card-block">
          {desc ? (
            <div className="card-desc"><i className="fa fa-exclamation-triangle" aria-hidden="true" /> {desc}</div>
            ) : null}
          {children}
        </div>
      </div>
    );
  }
}

Card.propTypes = {
    title: PropTypes.string,
  children: PropTypes.any,
  iconClass: PropTypes.any,
  className: PropTypes.any,
  contentIc: PropTypes.any,
  insulationIc: PropTypes.any,
  valveIc: PropTypes.any,
  settingsMenu: PropTypes.any,
  desc: PropTypes.any,
};

export default Card;
